(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["able-react"] = factory();
	else
		root["able-react"] = factory();
})(this, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 6942:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  BaseBlack: () => (/* reexport */ GeneratedLogoComponents_BaseBlack),
  BaseEarth60AndSky60: () => (/* reexport */ GeneratedLogoComponents_BaseEarth60AndSky60),
  BaseEarth60AndWhite: () => (/* reexport */ GeneratedLogoComponents_BaseEarth60AndWhite),
  BaseSky60AndWhite: () => (/* reexport */ GeneratedLogoComponents_BaseSky60AndWhite),
  BaseWhite: () => (/* reexport */ GeneratedLogoComponents_BaseWhite),
  InternationalBlack: () => (/* reexport */ GeneratedLogoComponents_InternationalBlack),
  InternationalEarth60AndSky60: () => (/* reexport */ GeneratedLogoComponents_InternationalEarth60AndSky60),
  InternationalEarth60AndWhite: () => (/* reexport */ GeneratedLogoComponents_InternationalEarth60AndWhite),
  InternationalSky60AndWhite: () => (/* reexport */ GeneratedLogoComponents_InternationalSky60AndWhite),
  InternationalWhite: () => (/* reexport */ GeneratedLogoComponents_InternationalWhite),
  TelstraPlusBlack: () => (/* reexport */ GeneratedLogoComponents_TelstraPlusBlack),
  TelstraPlusEarth60AndSky60: () => (/* reexport */ GeneratedLogoComponents_TelstraPlusEarth60AndSky60),
  TelstraPlusEarth60AndWhite: () => (/* reexport */ GeneratedLogoComponents_TelstraPlusEarth60AndWhite),
  TelstraPlusSky60AndWhite: () => (/* reexport */ GeneratedLogoComponents_TelstraPlusSky60AndWhite),
  TelstraPlusWhite: () => (/* reexport */ GeneratedLogoComponents_TelstraPlusWhite),
  "default": () => (/* binding */ src_Logo)
});

;// external "@babel/runtime/helpers/defineProperty"
const defineProperty_namespaceObject = require("@babel/runtime/helpers/defineProperty");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_namespaceObject);
;// external "@babel/runtime/helpers/objectWithoutProperties"
const objectWithoutProperties_namespaceObject = require("@babel/runtime/helpers/objectWithoutProperties");
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties_namespaceObject);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(6942);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// external "react"
const external_react_namespaceObject = require("react");
;// external "react/jsx-runtime"
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
;// ./src/Logo/Logo.tsx


var _excluded = ["className", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



/**
 *
 * Illustrations help convey complex ideas in a simple way.
 * They should be meaningful and reflect a user's context and emotional state.
 * We use them to make technical information feel more human, and add some personality to the way we communicate.
 *
 * [View the Logo documentation on Confluence](https://confluence.tools.telstra.com/display/DCSYS/Logos)
 *
 * @version 1.0.0
 */

function Logo(props) {
  var className = props.className,
    children = props.children,
    other = objectWithoutProperties_default()(props, _excluded);
  var classes = className ? classnames_default()(className) : undefined; // see we provide no default styling, downstreams expected to set size and background colour

  var childProps = _objectSpread(_objectSpread({}, other), {}, {
    className: classes,
    focusable: 'false',
    'aria-hidden': 'true'
  });
  var SelectedLogo = function SelectedLogo() {
    return /*#__PURE__*/(0,external_react_namespaceObject.cloneElement)(children, childProps);
  };
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(SelectedLogo, {});
}
/* harmony default export */ const Logo_Logo = (Logo);
;// ./src/Logo/GeneratedLogoComponents/BaseBlack.tsx


var BaseBlack_excluded = ["className"];
function BaseBlack_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function BaseBlack_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? BaseBlack_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : BaseBlack_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function BaseBlack(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BaseBlack_excluded);
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("svg", BaseBlack_objectSpread(BaseBlack_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 873.8 1000",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("path", {
      d: "M829.6 847c0 39.4-9.4 74.2-33.1 101-30 34.7-75.8 52-132.5 52-113.7 0-269.8-66.3-411.8-184.6C93 681.5 0 517.4 0 399.1c0-39.4 11.1-72.5 33.2-99.4 31.5-37.8 78.8-53.5 137.1-53.5 53.4 0 118.7 17.1 184.4 44.3L271.4 750h216c46.4 0 79.7-28.7 89.2-77.6L612 464.5c135 126 217.6 274.6 217.6 382.5zM263.4 0c-28.4 0-52 19.1-58.3 49l-25.2 137.1H405l-96.7 533h179.1c23.9 0 50.8-11.1 58.8-51.9l81.9-481.1h162c28.5 0 52.1-18.9 58.4-48.9L873.8 0H263.4z"
    })
  }));
}
/* harmony default export */ const GeneratedLogoComponents_BaseBlack = (BaseBlack);
;// ./src/Logo/GeneratedLogoComponents/BaseEarth60AndSky60.tsx


var BaseEarth60AndSky60_excluded = ["className"];
function BaseEarth60AndSky60_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function BaseEarth60AndSky60_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? BaseEarth60AndSky60_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : BaseEarth60AndSky60_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function BaseEarth60AndSky60(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BaseEarth60AndSky60_excluded);
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("svg", BaseEarth60AndSky60_objectSpread(BaseEarth60AndSky60_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 873.8 1000",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("path", {
      d: "m584.9 440.1-38.7 227.2c-8 40.9-34.9 51.9-58.8 51.9h-179l75.5-416.1c-75.3-34.5-152.3-57-213.5-57-58.3 0-105.6 15.8-137.1 53.5C11.1 326.5 0 359.7 0 399.1c0 118.3 93 282.4 252.3 416.3C394.2 933.7 550.4 1000 664 1000c56.7 0 102.4-17.4 132.5-52 23.6-26.8 33.1-61.6 33.1-101 0-115-93.7-276.1-244.7-406.9z",
      style: {
        fill: '#f96449'
      }
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("path", {
      d: "M263.4 0c-28.4 0-52 19.1-58.3 49l-25.2 137.1H405l-96.7 533h179.1c23.9 0 50.8-11.1 58.8-51.9l81.9-481.1h162c28.5 0 52.1-18.9 58.4-48.9L873.8 0H263.4z",
      style: {
        fill: '#0d54ff'
      }
    })]
  }));
}
/* harmony default export */ const GeneratedLogoComponents_BaseEarth60AndSky60 = (BaseEarth60AndSky60);
;// ./src/Logo/GeneratedLogoComponents/BaseEarth60AndWhite.tsx


var BaseEarth60AndWhite_excluded = ["className"];
function BaseEarth60AndWhite_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function BaseEarth60AndWhite_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? BaseEarth60AndWhite_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : BaseEarth60AndWhite_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function BaseEarth60AndWhite(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BaseEarth60AndWhite_excluded);
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("svg", BaseEarth60AndWhite_objectSpread(BaseEarth60AndWhite_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 873.8 1000",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("path", {
      d: "m584.9 440.1-38.7 227.2c-8 40.9-34.9 51.9-58.8 51.9h-179l75.5-416.1c-75.3-34.5-152.3-57-213.5-57-58.3 0-105.6 15.8-137.1 53.5C11.1 326.5 0 359.7 0 399.1c0 118.3 93 282.4 252.3 416.3C394.2 933.7 550.4 1000 664 1000c56.7 0 102.4-17.4 132.5-52 23.6-26.8 33.1-61.6 33.1-101 0-115-93.7-276.1-244.7-406.9z",
      style: {
        fill: '#f96449'
      }
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("path", {
      d: "M263.4 0c-28.4 0-52 19.1-58.3 49l-25.2 137.1H405l-96.7 533h179.1c23.9 0 50.8-11.1 58.8-51.9l81.9-481.1h162c28.5 0 52.1-18.9 58.4-48.9L873.8 0H263.4z",
      style: {
        fill: '#fff'
      }
    })]
  }));
}
/* harmony default export */ const GeneratedLogoComponents_BaseEarth60AndWhite = (BaseEarth60AndWhite);
;// ./src/Logo/GeneratedLogoComponents/BaseSky60AndWhite.tsx


var BaseSky60AndWhite_excluded = ["className"];
function BaseSky60AndWhite_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function BaseSky60AndWhite_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? BaseSky60AndWhite_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : BaseSky60AndWhite_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function BaseSky60AndWhite(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BaseSky60AndWhite_excluded);
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("svg", BaseSky60AndWhite_objectSpread(BaseSky60AndWhite_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 873.8 1000",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("path", {
      d: "m584.9 440.1-38.7 227.2c-8 40.9-34.9 51.9-58.8 51.9h-179l75.5-416.1c-75.3-34.5-152.3-57-213.5-57-58.3 0-105.6 15.8-137.1 53.5C11.1 326.5 0 359.7 0 399.1c0 118.3 93 282.4 252.3 416.3C394.2 933.7 550.4 1000 664 1000c56.7 0 102.4-17.4 132.5-52 23.6-26.8 33.1-61.6 33.1-101 0-115-93.7-276.1-244.7-406.9z",
      style: {
        fill: '#0d54ff'
      }
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("path", {
      d: "M263.4 0c-28.4 0-52 19.1-58.3 49l-25.2 137.1H405l-96.7 533h179.1c23.9 0 50.8-11.1 58.8-51.9l81.9-481.1h162c28.5 0 52.1-18.9 58.4-48.9L873.8 0H263.4z",
      style: {
        fill: '#fff'
      }
    })]
  }));
}
/* harmony default export */ const GeneratedLogoComponents_BaseSky60AndWhite = (BaseSky60AndWhite);
;// ./src/Logo/GeneratedLogoComponents/BaseWhite.tsx


var BaseWhite_excluded = ["className"];
function BaseWhite_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function BaseWhite_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? BaseWhite_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : BaseWhite_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function BaseWhite(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BaseWhite_excluded);
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("svg", BaseWhite_objectSpread(BaseWhite_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 873.8 1000",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("path", {
      d: "M829.6 847c0 39.4-9.4 74.2-33.1 101-30 34.7-75.8 52-132.5 52-113.7 0-269.8-66.3-411.8-184.6C93 681.5 0 517.4 0 399.1c0-39.4 11.1-72.5 33.2-99.4 31.5-37.8 78.8-53.5 137.1-53.5 53.4 0 118.7 17.1 184.4 44.3L271.4 750h216c46.4 0 79.7-28.7 89.2-77.6L612 464.5c135 126 217.6 274.6 217.6 382.5zM263.4 0c-28.4 0-52 19.1-58.3 49l-25.2 137.1H405l-96.7 533h179.1c23.9 0 50.8-11.1 58.8-51.9l81.9-481.1h162c28.5 0 52.1-18.9 58.4-48.9L873.8 0H263.4z",
      style: {
        fill: '#fff'
      }
    })
  }));
}
/* harmony default export */ const GeneratedLogoComponents_BaseWhite = (BaseWhite);
;// ./src/Logo/GeneratedLogoComponents/InternationalBlack.tsx


var InternationalBlack_excluded = ["className"];
function InternationalBlack_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function InternationalBlack_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? InternationalBlack_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : InternationalBlack_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function InternationalBlack(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, InternationalBlack_excluded);
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("svg", InternationalBlack_objectSpread(InternationalBlack_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 3639 1000",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("path", {
      d: "M3305.4 558.8c-46.6 0-80.1-41.6-80.1-98.4 0-72 38.5-129.8 100.4-129.8 50.7 0 84.2 41.6 84.2 98.4-.1 76.1-43.7 129.8-104.5 129.8m153.1-392.5-11.2 56.8c-28.4-42.6-79.1-66.9-146-66.9-160.2 0-274.8 142-274.8 331.6 0 136.9 88.2 242.4 212 242.4 57.8 0 108.5-27.4 143-72l-10.1 60.9h170.4l97.4-552.7h-180.7zM1158.2 384.4H992.9c16.2-49.7 46.6-74 91.3-74 63.9 0 74 47.7 74 63.9v10.1zm-58.8-231.3C876.3 153.1 784 334.7 784 480.7c0 90.3 58.8 251.5 271.8 251.5 118.7 0 191.7-49.7 231.2-117.6l-141-85.2c-23.3 31.4-49.7 45.6-83.2 45.6-46.7 0-81.1-23.3-83.2-83.2h357c5.1-20.3 10.1-50.7 10.1-99.4.1-130.7-92.2-239.3-247.3-239.3M2987.1 158.2c-34.5 0-100.4 14.2-134.9 71l8.1-62.9H2693L2595.6 719h201.8l47.7-273.8c12.2-55.8 61.9-96.3 115.6-96.3 18.3 0 27.4 1 36.5 4.1l37.5-188.6c-11.1-4.2-32.4-6.2-47.6-6.2M2446.2 325.6h121.7l28.4-159.2h-122.7l22.3-134.9h-197.8l-74 434.1c-29.4 170.4 86.2 256.6 218 256.6 30.4 0 48.7-3 57.8-5.1l29.4-167.3c-3 1-13.2 3-25.4 3-49.7 0-91.3-26.4-80.1-91.3l22.4-135.9zM1496.2 0l-126.7 719.1h200.8L1697 0zM1939.8 296.1c36.5 0 55.8 18.3 69 52.7l174.4-36.5C2168 217 2087.8 153.1 1958 153.1c-160.2 0-248.5 95.3-248.5 200.8 0 72 44.6 120.7 138.9 142l81.1 18.3c35.5 8.1 41.6 22.3 41.6 37.5 0 21.3-17.2 37.5-49.7 37.5-38.5 0-69-18.3-78.1-59.8L1670 566.9c11.2 117.6 130.8 165.3 238.3 165.3 157.2 0 246.4-80.1 246.4-194.7 0-76.1-43.6-128.8-136.9-149.1l-80.1-17.2c-38.5-8.1-49.7-16.2-49.7-37.5 0-19.3 16.3-37.6 51.8-37.6M829.6 847c0 39.4-9.4 74.2-33.1 101-30 34.7-75.8 52-132.5 52-113.7 0-269.8-66.3-411.8-184.6C93 681.5 0 517.4 0 399.1c0-39.4 11.1-72.5 33.2-99.4 31.5-37.8 78.8-53.5 137.1-53.5 53.4 0 118.7 17.1 184.4 44.3L271.4 750h216c46.4 0 79.7-28.7 89.2-77.6L612 464.5c135 126 217.6 274.6 217.6 382.5zM263.4 0c-28.4 0-52 19.1-58.3 49l-25.2 137.1H405l-96.7 533h179.1c23.9 0 50.8-11.1 58.8-51.9l81.9-481.1h162c28.5 0 52.1-18.9 58.4-48.9L873.8 0H263.4z"
    })
  }));
}
/* harmony default export */ const GeneratedLogoComponents_InternationalBlack = (InternationalBlack);
;// ./src/Logo/GeneratedLogoComponents/InternationalEarth60AndSky60.tsx


var InternationalEarth60AndSky60_excluded = ["className"];
function InternationalEarth60AndSky60_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function InternationalEarth60AndSky60_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? InternationalEarth60AndSky60_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : InternationalEarth60AndSky60_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function InternationalEarth60AndSky60(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, InternationalEarth60AndSky60_excluded);
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("svg", InternationalEarth60AndSky60_objectSpread(InternationalEarth60AndSky60_objectSpread({
    version: "1.1",
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 3639 1000",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("path", {
      d: "m584.9 440.1-38.7 227.2c-8 40.9-34.9 51.9-58.8 51.9h-179l75.5-416.1c-75.3-34.5-152.3-57-213.5-57-58.3 0-105.6 15.8-137.1 53.5C11.1 326.5 0 359.7 0 399.1c0 118.3 93 282.4 252.3 416.3C394.2 933.7 550.4 1000 664 1000c56.7 0 102.4-17.4 132.5-52 23.6-26.8 33.1-61.6 33.1-101 0-115-93.7-276.1-244.7-406.9z",
      style: {
        fill: '#f96449'
      }
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("path", {
      d: "M263.4 0c-28.4 0-52 19.1-58.3 49l-25.2 137.1H405l-96.7 533h179.1c23.9 0 50.8-11.1 58.8-51.9l81.9-481.1h162c28.5 0 52.1-18.9 58.4-48.9L873.8 0H263.4zM3305.4 558.8c-46.6 0-80.1-41.6-80.1-98.4 0-72 38.5-129.8 100.4-129.8 50.7 0 84.2 41.6 84.2 98.4-.1 76.1-43.7 129.8-104.5 129.8m153.1-392.5-11.2 56.8c-28.4-42.6-79.1-66.9-146-66.9-160.2 0-274.8 142-274.8 331.6 0 136.9 88.2 242.4 212 242.4 57.8 0 108.5-27.4 143-72l-10.1 60.9h170.4l97.4-552.7h-180.7v-.1zM1158.2 384.4H992.9c16.2-49.7 46.6-74 91.3-74 63.9 0 74 47.7 74 63.9v10.1zm-58.8-231.3C876.3 153.1 784 334.7 784 480.7c0 90.3 58.8 251.5 271.8 251.5 118.7 0 191.7-49.7 231.2-117.6l-141-85.2c-23.3 31.4-49.7 45.6-83.2 45.6-46.7 0-81.1-23.3-83.2-83.2h357c5.1-20.3 10.1-50.7 10.1-99.4.1-130.7-92.2-239.3-247.3-239.3M2987.1 158.2c-34.5 0-100.4 14.2-134.9 71l8.1-62.9H2693L2595.6 719h201.8l47.7-273.8c12.2-55.8 61.9-96.3 115.6-96.3 18.3 0 27.4 1 36.5 4.1l37.5-188.6c-11.1-4.2-32.4-6.2-47.6-6.2M2446.2 325.6h121.7l28.4-159.2h-122.7l22.3-134.9h-197.8l-74 434.1c-29.4 170.4 86.2 256.6 218 256.6 30.4 0 48.7-3 57.8-5.1l29.4-167.3c-3 1-13.2 3-25.4 3-49.7 0-91.3-26.4-80.1-91.3l22.4-135.9zM1496.2 0l-126.7 719.1h200.8L1697 0zM1939.8 296.1c36.5 0 55.8 18.3 69 52.7l174.4-36.5C2168 217 2087.8 153.1 1958 153.1c-160.2 0-248.5 95.3-248.5 200.8 0 72 44.6 120.7 138.9 142l81.1 18.3c35.5 8.1 41.6 22.3 41.6 37.5 0 21.3-17.2 37.5-49.7 37.5-38.5 0-69-18.3-78.1-59.8L1670 566.9c11.2 117.6 130.8 165.3 238.3 165.3 157.2 0 246.4-80.1 246.4-194.7 0-76.1-43.6-128.8-136.9-149.1l-80.1-17.2c-38.5-8.1-49.7-16.2-49.7-37.5 0-19.3 16.3-37.6 51.8-37.6",
      style: {
        fill: '#0d54ff'
      }
    })]
  }));
}
/* harmony default export */ const GeneratedLogoComponents_InternationalEarth60AndSky60 = (InternationalEarth60AndSky60);
;// ./src/Logo/GeneratedLogoComponents/InternationalEarth60AndWhite.tsx


var InternationalEarth60AndWhite_excluded = ["className"];
function InternationalEarth60AndWhite_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function InternationalEarth60AndWhite_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? InternationalEarth60AndWhite_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : InternationalEarth60AndWhite_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function InternationalEarth60AndWhite(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, InternationalEarth60AndWhite_excluded);
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("svg", InternationalEarth60AndWhite_objectSpread(InternationalEarth60AndWhite_objectSpread({
    version: "1.1",
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 3639 1000",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("path", {
      d: "m584.9 440.1-38.7 227.2c-8 40.9-34.9 51.9-58.8 51.9h-179l75.5-416.1c-75.3-34.5-152.3-57-213.5-57-58.3 0-105.6 15.8-137.1 53.5C11.1 326.5 0 359.7 0 399.1c0 118.3 93 282.4 252.3 416.3C394.2 933.7 550.4 1000 664 1000c56.7 0 102.4-17.4 132.5-52 23.6-26.8 33.1-61.6 33.1-101 0-115-93.7-276.1-244.7-406.9z",
      style: {
        fill: '#f96449'
      }
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("path", {
      d: "M263.4 0c-28.4 0-52 19.1-58.3 49l-25.2 137.1H405l-96.7 533h179.1c23.9 0 50.8-11.1 58.8-51.9l81.9-481.1h162c28.5 0 52.1-18.9 58.4-48.9L873.8 0H263.4zM3305.4 558.8c-46.6 0-80.1-41.6-80.1-98.4 0-72 38.5-129.8 100.4-129.8 50.7 0 84.2 41.6 84.2 98.4-.1 76.1-43.7 129.8-104.5 129.8m153.1-392.5-11.2 56.8c-28.4-42.6-79.1-66.9-146-66.9-160.2 0-274.8 142-274.8 331.6 0 136.9 88.2 242.4 212 242.4 57.8 0 108.5-27.4 143-72l-10.1 60.9h170.4l97.4-552.7h-180.7v-.1zM1158.2 384.4H992.9c16.2-49.7 46.6-74 91.3-74 63.9 0 74 47.7 74 63.9v10.1zm-58.8-231.3C876.3 153.1 784 334.7 784 480.7c0 90.3 58.8 251.5 271.8 251.5 118.7 0 191.7-49.7 231.2-117.6l-141-85.2c-23.3 31.4-49.7 45.6-83.2 45.6-46.7 0-81.1-23.3-83.2-83.2h357c5.1-20.3 10.1-50.7 10.1-99.4.1-130.7-92.2-239.3-247.3-239.3M2987.1 158.2c-34.5 0-100.4 14.2-134.9 71l8.1-62.9H2693L2595.6 719h201.8l47.7-273.8c12.2-55.8 61.9-96.3 115.6-96.3 18.3 0 27.4 1 36.5 4.1l37.5-188.6c-11.1-4.2-32.4-6.2-47.6-6.2M2446.2 325.6h121.7l28.4-159.2h-122.7l22.3-134.9h-197.8l-74 434.1c-29.4 170.4 86.2 256.6 218 256.6 30.4 0 48.7-3 57.8-5.1l29.4-167.3c-3 1-13.2 3-25.4 3-49.7 0-91.3-26.4-80.1-91.3l22.4-135.9zM1496.2 0l-126.7 719.1h200.8L1697 0zM1939.8 296.1c36.5 0 55.8 18.3 69 52.7l174.4-36.5C2168 217 2087.8 153.1 1958 153.1c-160.2 0-248.5 95.3-248.5 200.8 0 72 44.6 120.7 138.9 142l81.1 18.3c35.5 8.1 41.6 22.3 41.6 37.5 0 21.3-17.2 37.5-49.7 37.5-38.5 0-69-18.3-78.1-59.8L1670 566.9c11.2 117.6 130.8 165.3 238.3 165.3 157.2 0 246.4-80.1 246.4-194.7 0-76.1-43.6-128.8-136.9-149.1l-80.1-17.2c-38.5-8.1-49.7-16.2-49.7-37.5 0-19.3 16.3-37.6 51.8-37.6",
      style: {
        fill: '#fff'
      }
    })]
  }));
}
/* harmony default export */ const GeneratedLogoComponents_InternationalEarth60AndWhite = (InternationalEarth60AndWhite);
;// ./src/Logo/GeneratedLogoComponents/InternationalSky60AndWhite.tsx


var InternationalSky60AndWhite_excluded = ["className"];
function InternationalSky60AndWhite_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function InternationalSky60AndWhite_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? InternationalSky60AndWhite_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : InternationalSky60AndWhite_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function InternationalSky60AndWhite(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, InternationalSky60AndWhite_excluded);
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("svg", InternationalSky60AndWhite_objectSpread(InternationalSky60AndWhite_objectSpread({
    version: "1.1",
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 3639 1000",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("path", {
      d: "m584.9 440.1-38.7 227.2c-8 40.9-34.9 51.9-58.8 51.9h-179l75.5-416.1c-75.3-34.5-152.3-57-213.5-57-58.3 0-105.6 15.8-137.1 53.5C11.1 326.5 0 359.7 0 399.1c0 118.3 93 282.4 252.3 416.3C394.2 933.7 550.4 1000 664 1000c56.7 0 102.4-17.4 132.5-52 23.6-26.8 33.1-61.6 33.1-101 0-115-93.7-276.1-244.7-406.9z",
      style: {
        fill: '#0d54ff'
      }
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("path", {
      d: "M263.4 0c-28.4 0-52 19.1-58.3 49l-25.2 137.1H405l-96.7 533h179.1c23.9 0 50.8-11.1 58.8-51.9l81.9-481.1h162c28.5 0 52.1-18.9 58.4-48.9L873.8 0H263.4zM3305.4 558.8c-46.6 0-80.1-41.6-80.1-98.4 0-72 38.5-129.8 100.4-129.8 50.7 0 84.2 41.6 84.2 98.4-.1 76.1-43.7 129.8-104.5 129.8m153.1-392.5-11.2 56.8c-28.4-42.6-79.1-66.9-146-66.9-160.2 0-274.8 142-274.8 331.6 0 136.9 88.2 242.4 212 242.4 57.8 0 108.5-27.4 143-72l-10.1 60.9h170.4l97.4-552.7h-180.7zM1158.2 384.4H992.9c16.2-49.7 46.6-74 91.3-74 63.9 0 74 47.7 74 63.9v10.1zm-58.8-231.3C876.3 153.1 784 334.7 784 480.7c0 90.3 58.8 251.5 271.8 251.5 118.7 0 191.7-49.7 231.2-117.6l-141-85.2c-23.3 31.4-49.7 45.6-83.2 45.6-46.7 0-81.1-23.3-83.2-83.2h357c5.1-20.3 10.1-50.7 10.1-99.4.1-130.7-92.2-239.3-247.3-239.3M2987.1 158.2c-34.5 0-100.4 14.2-134.9 71l8.1-62.9H2693L2595.6 719h201.8l47.7-273.8c12.2-55.8 61.9-96.3 115.6-96.3 18.3 0 27.4 1 36.5 4.1l37.5-188.6c-11.1-4.2-32.4-6.2-47.6-6.2M2446.2 325.6h121.7l28.4-159.2h-122.7l22.3-134.9h-197.8l-74 434.1c-29.4 170.4 86.2 256.6 218 256.6 30.4 0 48.7-3 57.8-5.1l29.4-167.3c-3 1-13.2 3-25.4 3-49.7 0-91.3-26.4-80.1-91.3l22.4-135.9zM1496.2 0l-126.7 719.1h200.8L1697 0zM1939.8 296.1c36.5 0 55.8 18.3 69 52.7l174.4-36.5C2168 217 2087.8 153.1 1958 153.1c-160.2 0-248.5 95.3-248.5 200.8 0 72 44.6 120.7 138.9 142l81.1 18.3c35.5 8.1 41.6 22.3 41.6 37.5 0 21.3-17.2 37.5-49.7 37.5-38.5 0-69-18.3-78.1-59.8L1670 566.9c11.2 117.6 130.8 165.3 238.3 165.3 157.2 0 246.4-80.1 246.4-194.7 0-76.1-43.6-128.8-136.9-149.1l-80.1-17.2c-38.5-8.1-49.7-16.2-49.7-37.5 0-19.3 16.3-37.6 51.8-37.6",
      style: {
        fill: '#fff'
      }
    })]
  }));
}
/* harmony default export */ const GeneratedLogoComponents_InternationalSky60AndWhite = (InternationalSky60AndWhite);
;// ./src/Logo/GeneratedLogoComponents/InternationalWhite.tsx


var InternationalWhite_excluded = ["className"];
function InternationalWhite_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function InternationalWhite_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? InternationalWhite_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : InternationalWhite_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function InternationalWhite(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, InternationalWhite_excluded);
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("svg", InternationalWhite_objectSpread(InternationalWhite_objectSpread({
    version: "1.1",
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 3639 1000",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("path", {
      d: "M3305.4 558.8c-46.6 0-80.1-41.6-80.1-98.4 0-72 38.5-129.8 100.4-129.8 50.7 0 84.2 41.6 84.2 98.4-.1 76.1-43.7 129.8-104.5 129.8m153.1-392.5-11.2 56.8c-28.4-42.6-79.1-66.9-146-66.9-160.2 0-274.8 142-274.8 331.6 0 136.9 88.2 242.4 212 242.4 57.8 0 108.5-27.4 143-72l-10.1 60.9h170.4l97.4-552.7h-180.7zM1158.2 384.4H992.9c16.2-49.7 46.6-74 91.3-74 63.9 0 74 47.7 74 63.9v10.1zm-58.8-231.3C876.3 153.1 784 334.7 784 480.7c0 90.3 58.8 251.5 271.8 251.5 118.7 0 191.7-49.7 231.2-117.6l-141-85.2c-23.3 31.4-49.7 45.6-83.2 45.6-46.7 0-81.1-23.3-83.2-83.2h357c5.1-20.3 10.1-50.7 10.1-99.4.1-130.7-92.2-239.3-247.3-239.3M2987.1 158.2c-34.5 0-100.4 14.2-134.9 71l8.1-62.9H2693L2595.6 719h201.8l47.7-273.8c12.2-55.8 61.9-96.3 115.6-96.3 18.3 0 27.4 1 36.5 4.1l37.5-188.6c-11.1-4.2-32.4-6.2-47.6-6.2M2446.2 325.6h121.7l28.4-159.2h-122.7l22.3-134.9h-197.8l-74 434.1c-29.4 170.4 86.2 256.6 218 256.6 30.4 0 48.7-3 57.8-5.1l29.4-167.3c-3 1-13.2 3-25.4 3-49.7 0-91.3-26.4-80.1-91.3l22.4-135.9zM1496.2 0l-126.7 719.1h200.8L1697 0zM1939.8 296.1c36.5 0 55.8 18.3 69 52.7l174.4-36.5C2168 217 2087.8 153.1 1958 153.1c-160.2 0-248.5 95.3-248.5 200.8 0 72 44.6 120.7 138.9 142l81.1 18.3c35.5 8.1 41.6 22.3 41.6 37.5 0 21.3-17.2 37.5-49.7 37.5-38.5 0-69-18.3-78.1-59.8L1670 566.9c11.2 117.6 130.8 165.3 238.3 165.3 157.2 0 246.4-80.1 246.4-194.7 0-76.1-43.6-128.8-136.9-149.1l-80.1-17.2c-38.5-8.1-49.7-16.2-49.7-37.5 0-19.3 16.3-37.6 51.8-37.6M829.6 847c0 39.4-9.4 74.2-33.1 101-30 34.7-75.8 52-132.5 52-113.7 0-269.8-66.3-411.8-184.6C93 681.5 0 517.4 0 399.1c0-39.4 11.1-72.5 33.2-99.4 31.5-37.8 78.8-53.5 137.1-53.5 53.4 0 118.7 17.1 184.4 44.3L271.4 750h216c46.4 0 79.7-28.7 89.2-77.6L612 464.5c135 126 217.6 274.6 217.6 382.5zM263.4 0c-28.4 0-52 19.1-58.3 49l-25.2 137.1H405l-96.7 533h179.1c23.9 0 50.8-11.1 58.8-51.9l81.9-481.1h162c28.5 0 52.1-18.9 58.4-48.9L873.8 0H263.4z",
      style: {
        fill: '#fff'
      }
    })
  }));
}
/* harmony default export */ const GeneratedLogoComponents_InternationalWhite = (InternationalWhite);
;// ./src/Logo/GeneratedLogoComponents/TelstraPlusBlack.tsx


var TelstraPlusBlack_excluded = ["className"];
function TelstraPlusBlack_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TelstraPlusBlack_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TelstraPlusBlack_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TelstraPlusBlack_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function TelstraPlusBlack(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TelstraPlusBlack_excluded);
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("svg", TelstraPlusBlack_objectSpread(TelstraPlusBlack_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 1204.9 1000",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("path", {
      d: "M829.6 847c0 39.4-9.4 74.2-33.1 101-30 34.7-75.8 52-132.5 52-113.7 0-269.8-66.3-411.8-184.6C93 681.5 0 517.4 0 399.1c0-39.4 11.1-72.5 33.2-99.4 31.5-37.8 78.8-53.5 137.1-53.5 53.4 0 118.7 17.1 184.4 44.3L271.4 750h216c46.4 0 79.7-28.7 89.2-77.6L612 464.5c135 126 217.6 274.6 217.6 382.5zM263.4 0c-28.4 0-52 19.1-58.3 49l-25.2 137.1H405l-96.7 533h179.1c23.9 0 50.8-11.1 58.8-51.9l81.9-481.1h162c28.5 0 52.1-18.9 58.4-48.9L873.8 0H263.4zM898 589.5l31.5-166.8H759.7l11-60.2c3.3-18.3 19.3-31.7 38-31.7h137.5l25.6-138.6c3.4-18.3 19.3-31.6 38-31.6h57.1l-31.5 170.2H1205l-11 60.2c-3.3 18.3-19.3 31.7-38 31.7h-137.4L993 558.1c-3.4 18.2-19.4 31.4-37.9 31.4H898z"
    })
  }));
}
/* harmony default export */ const GeneratedLogoComponents_TelstraPlusBlack = (TelstraPlusBlack);
;// ./src/Logo/GeneratedLogoComponents/TelstraPlusEarth60AndSky60.tsx


var TelstraPlusEarth60AndSky60_excluded = ["className"];
function TelstraPlusEarth60AndSky60_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TelstraPlusEarth60AndSky60_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TelstraPlusEarth60AndSky60_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TelstraPlusEarth60AndSky60_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function TelstraPlusEarth60AndSky60(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TelstraPlusEarth60AndSky60_excluded);
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("svg", TelstraPlusEarth60AndSky60_objectSpread(TelstraPlusEarth60AndSky60_objectSpread({
    version: "1.1",
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 1204.9 1000",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("path", {
      d: "m584.9 440.1-38.7 227.2c-8 40.9-34.9 51.9-58.8 51.9h-179l75.5-416.1c-75.3-34.5-152.3-57-213.5-57-58.3 0-105.6 15.8-137.1 53.5C11.1 326.5 0 359.7 0 399.1c0 118.3 93 282.4 252.3 416.3C394.2 933.7 550.4 1000 664 1000c56.7 0 102.4-17.4 132.5-52 23.6-26.8 33.1-61.6 33.1-101 0-115-93.7-276.1-244.7-406.9z",
      style: {
        fill: '#f96449'
      }
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("path", {
      d: "M263.4 0c-28.4 0-52 19.1-58.3 49l-25.2 137.1H405l-96.7 533h179.1c23.9 0 50.8-11.1 58.8-51.9l81.9-481.1h162c28.5 0 52.1-18.9 58.4-48.9L873.8 0H263.4zM898 589.5l31.5-166.8H759.7l11-60.2c3.3-18.3 19.3-31.7 38-31.7h137.5l25.6-138.6c3.4-18.3 19.3-31.6 38-31.6h57.1l-31.5 170.2H1205l-11 60.2c-3.3 18.3-19.3 31.7-38 31.7h-137.4L993 558.1c-3.4 18.2-19.4 31.4-37.9 31.4H898z",
      style: {
        fill: '#0d54ff'
      }
    })]
  }));
}
/* harmony default export */ const GeneratedLogoComponents_TelstraPlusEarth60AndSky60 = (TelstraPlusEarth60AndSky60);
;// ./src/Logo/GeneratedLogoComponents/TelstraPlusEarth60AndWhite.tsx


var TelstraPlusEarth60AndWhite_excluded = ["className"];
function TelstraPlusEarth60AndWhite_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TelstraPlusEarth60AndWhite_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TelstraPlusEarth60AndWhite_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TelstraPlusEarth60AndWhite_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function TelstraPlusEarth60AndWhite(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TelstraPlusEarth60AndWhite_excluded);
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("svg", TelstraPlusEarth60AndWhite_objectSpread(TelstraPlusEarth60AndWhite_objectSpread({
    version: "1.1",
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 1204.9 1000",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("path", {
      d: "m584.9 440.1-38.7 227.2c-8 40.9-34.9 51.9-58.8 51.9h-179l75.5-416.1c-75.3-34.5-152.3-57-213.5-57-58.3 0-105.6 15.8-137.1 53.5C11.1 326.5 0 359.7 0 399.1c0 118.3 93 282.4 252.3 416.3C394.2 933.7 550.4 1000 664 1000c56.7 0 102.4-17.4 132.5-52 23.6-26.8 33.1-61.6 33.1-101 0-115-93.7-276.1-244.7-406.9z",
      style: {
        fill: '#f96449'
      }
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("path", {
      d: "M263.4 0c-28.4 0-52 19.1-58.3 49l-25.2 137.1H405l-96.7 533h179.1c23.9 0 50.8-11.1 58.8-51.9l81.9-481.1h162c28.5 0 52.1-18.9 58.4-48.9L873.8 0H263.4zM898 589.5l31.5-166.8H759.7l11-60.2c3.3-18.3 19.3-31.7 38-31.7h137.5l25.6-138.6c3.4-18.3 19.3-31.6 38-31.6h57.1l-31.5 170.2H1205l-11 60.2c-3.3 18.3-19.3 31.7-38 31.7h-137.4L993 558.1c-3.4 18.2-19.4 31.4-37.9 31.4H898z",
      style: {
        fill: '#fff'
      }
    })]
  }));
}
/* harmony default export */ const GeneratedLogoComponents_TelstraPlusEarth60AndWhite = (TelstraPlusEarth60AndWhite);
;// ./src/Logo/GeneratedLogoComponents/TelstraPlusSky60AndWhite.tsx


var TelstraPlusSky60AndWhite_excluded = ["className"];
function TelstraPlusSky60AndWhite_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TelstraPlusSky60AndWhite_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TelstraPlusSky60AndWhite_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TelstraPlusSky60AndWhite_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function TelstraPlusSky60AndWhite(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TelstraPlusSky60AndWhite_excluded);
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("svg", TelstraPlusSky60AndWhite_objectSpread(TelstraPlusSky60AndWhite_objectSpread({
    version: "1.1",
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 1204.9 1000",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("path", {
      d: "m584.9 440.1-38.7 227.2c-8 40.9-34.9 51.9-58.8 51.9h-179l75.5-416.1c-75.3-34.5-152.3-57-213.5-57-58.3 0-105.6 15.8-137.1 53.5C11.1 326.5 0 359.7 0 399.1c0 118.3 93 282.4 252.3 416.3C394.2 933.7 550.4 1000 664 1000c56.7 0 102.4-17.4 132.5-52 23.6-26.8 33.1-61.6 33.1-101 0-115-93.7-276.1-244.7-406.9z",
      style: {
        fill: '#0d54ff'
      }
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("path", {
      d: "M263.4 0c-28.4 0-52 19.1-58.3 49l-25.2 137.1H405l-96.7 533h179.1c23.9 0 50.8-11.1 58.8-51.9l81.9-481.1h162c28.5 0 52.1-18.9 58.4-48.9L873.8 0H263.4zM898 589.5l31.5-166.8H759.7l11-60.2c3.3-18.3 19.3-31.7 38-31.7h137.5l25.6-138.6c3.4-18.3 19.3-31.6 38-31.6h57.1l-31.5 170.2H1205l-11 60.2c-3.3 18.3-19.3 31.7-38 31.7h-137.4L993 558.1c-3.4 18.2-19.4 31.4-37.9 31.4H898z",
      style: {
        fill: '#fff'
      }
    })]
  }));
}
/* harmony default export */ const GeneratedLogoComponents_TelstraPlusSky60AndWhite = (TelstraPlusSky60AndWhite);
;// ./src/Logo/GeneratedLogoComponents/TelstraPlusWhite.tsx


var TelstraPlusWhite_excluded = ["className"];
function TelstraPlusWhite_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TelstraPlusWhite_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TelstraPlusWhite_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TelstraPlusWhite_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function TelstraPlusWhite(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TelstraPlusWhite_excluded);
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("svg", TelstraPlusWhite_objectSpread(TelstraPlusWhite_objectSpread({
    version: "1.1",
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 1204.9 1000",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("path", {
      d: "M829.6 847c0 39.4-9.4 74.2-33.1 101-30 34.7-75.8 52-132.5 52-113.7 0-269.8-66.3-411.8-184.6C93 681.5 0 517.4 0 399.1c0-39.4 11.1-72.5 33.2-99.4 31.5-37.8 78.8-53.5 137.1-53.5 53.4 0 118.7 17.1 184.4 44.3L271.4 750h216c46.4 0 79.7-28.7 89.2-77.6L612 464.5c135 126 217.6 274.6 217.6 382.5zM263.4 0c-28.4 0-52 19.1-58.3 49l-25.2 137.1H405l-96.7 533h179.1c23.9 0 50.8-11.1 58.8-51.9l81.9-481.1h162c28.5 0 52.1-18.9 58.4-48.9L873.8 0H263.4zM898 589.5l31.5-166.8H759.7l11-60.2c3.3-18.3 19.3-31.7 38-31.7h137.5l25.6-138.6c3.4-18.3 19.3-31.6 38-31.6h57.1l-31.5 170.2H1205l-11 60.2c-3.3 18.3-19.3 31.7-38 31.7h-137.4L993 558.1c-3.4 18.2-19.4 31.4-37.9 31.4H898z",
      style: {
        fill: '#fff'
      }
    })
  }));
}
/* harmony default export */ const GeneratedLogoComponents_TelstraPlusWhite = (TelstraPlusWhite);
;// ./src/Logo/GeneratedLogoComponents/index.tsx
















;// ./src/Logo/index.ts


/* harmony default export */ const src_Logo = (Logo_Logo);
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});